import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { EyeIcon, EyeOffIcon } from 'lucide-react';

export const PasswordInput = ({ field }: { field: any }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative w-full">
      <Input
        placeholder="e.g. bn921lksnfks1234567890"
        {...field}
        type={showPassword ? 'text' : 'password'}
        className="pr-10"
      />
      <button
        type="button"
        onClick={() => {
          setShowPassword(!showPassword);
        }}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1"
      >
        {showPassword ? (
          <EyeOffIcon className="h-4 w-4 text-gray-400" />
        ) : (
          <EyeIcon className="h-4 w-4 text-gray-400" />
        )}
      </button>
    </div>
  );
};
